// Co-located copy of the image-URL helper so this shared component carries no host-only `~/`
// dependency and ships standalone — the same convention atlas-astro and the BannersCarousel package
// follow (each context keeps its own small copy rather than reaching across a build boundary).
export function getWebPImageUrlWithWidth(url: string, width: number) {
  try {
    const u = new URL(url);
    u.searchParams.set('fm', 'webp');
    u.searchParams.set('w', String(width));
    return u.toString();
  } catch {
    // If url is relative or invalid, fallback to manual append
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}fm=webp&w=${width}`;
  }
}
